const useFormDataFormatter = (formContent) => {
  formContent.map((item) => {
    item.fields.map((field) => {
      if (field.options) {
        field.options = optionsFormatter(field.options);
      }
      return field;
    });
    return item;
  });
  return formContent;
};

export default useFormDataFormatter;

const optionsFormatter = (value) => {
  if (typeof value === "function") {
    return value();
  }
  return value;
};
